import React, {useEffect, useMemo, useState} from "react";
import {Box, Stack} from "@mui/material";
import importedStyles from "../Utilities/styles";
import useLocationQueryDateRange from "../../../hooks/useLocationQueryDateRange";
import CampaignsTable from "../Utilities/CampaignsTable";
import useLocationQueryParams from "../../../hooks/useLocationQueryParams";
import moment from "moment";
import GetCampaignForm from "../Utilities/GetCampaignsForm";
import {queryStringToObject} from "_helpers";
import useGetRetainCampaigns from "../../RetainDashboard/Utilities/hooks/useGetRetainCampaigns";
import useGetAcquireCampaigns from "../../AcquireDashboard/Utilities/hooks/useGetAcquireCampaigns";
import { ACQUIRE_CAMPAIGNS, RETAIN_CAMPAIGNS } from "../../RetainDashboard/Utilities/CampaignUtils";
import { SnackBar } from "components/common";

export default function Campaigns() {
    const { startDate, endDate, setDates } = useLocationQueryDateRange({
            initialStartDate: moment().subtract(2, 'years')
        });
    const { params, setParams } = useLocationQueryParams();
    const [refreshTrigger, setRefreshTrigger] = useState(0);

    const payload = {
        startDate: moment(startDate).startOf('day').toISOString(),
        endDate: moment(endDate).endOf('day').toISOString()
    }

    const search = window.location.search.substring(1);
    const urlParams =  queryStringToObject(search);

    const [organizationId, setOrganizationId] = useState(()=> _.get(urlParams, 'organizationId') || "");  
    const [pageFilter, setPageFilter] = useState(()=> _.get(urlParams, 'pageFilter') || RETAIN_CAMPAIGNS);

    const retainCampaignData = useGetRetainCampaigns({
        organizationId,
        ...payload,
        refreshTrigger,
        enabled: refreshTrigger > 0 && pageFilter === RETAIN_CAMPAIGNS,
    });

    const acquireCampaignData = useGetAcquireCampaigns({
        organizationId,
        ...payload,
        refreshTrigger,
        enabled: refreshTrigger > 0 && pageFilter === ACQUIRE_CAMPAIGNS,
    });
    const retainRows = retainCampaignData?.rows 
    const acquireRows = acquireCampaignData?.rows 

    const campaignData = useMemo(() => {
      switch (pageFilter) {
        case RETAIN_CAMPAIGNS:
          return retainCampaignData;
        case ACQUIRE_CAMPAIGNS:
          return acquireCampaignData;
        default:
          return { rows: [], columns: [], totalCount: 0, loading: false };
      }
    }, [
      pageFilter,
      refreshTrigger,
      retainRows,
      acquireRows,
    ]);

    const { rows, columns, totalCount, loading, changePage, page, order, orderBy, handleRequestSort } = campaignData;

    const handlePageChange = (event, nextPage) => {
        changePage(nextPage);
    };

    const handleTableCellClick = (params) => {
        if (params) {
            window.location.replace(params);
        } else {
            SnackBar.showMessage("Please browse the messages on the source platform.");
        }
    }

    const getTableTitle = () => {
        switch(pageFilter) {
            case RETAIN_CAMPAIGNS:
                return 'Retain Campaigns';
            case ACQUIRE_CAMPAIGNS:
                return 'Acquire Campaigns';
            default:
                return 'Proactive Campaigns';
        }
    };

    const handleFormSubmit = () => {
        setRefreshTrigger(prev=>prev+1)
        changePage(0);
    }

    useEffect(() => {
        if (!params.pageFilter) {
            setParams({ ...params, pageFilter: RETAIN_CAMPAIGNS });
        }
    }, []);

    return(
        <>
            <Box sx={styles.root}>
                <Box sx={styles.container}>
                    <Stack direction={{ xs: 'column', md: 'row' }} sx={styles.hero} spacing={2}>
                        <Box component={'h1'} sx={importedStyles.headingLarge}>
                            {getTableTitle()}
                        </Box>
                        <GetCampaignForm 
                            organizationId={organizationId}
                            pageFilter={pageFilter}
                            setOrganizationId={setOrganizationId}
                            setPageFilter={setPageFilter}
                            startDate={startDate}
                            endDate={endDate}
                            setDates={setDates}
                            onSubmit={handleFormSubmit}
                        />
                    </Stack>

                    <Box>
                        <CampaignsTable
                            rows={rows}
                            columns={columns}
                            totalCount={totalCount}
                            page={page}
                            loading={loading}
                            handlePageChange={handlePageChange}
                            handleTableCellClick={handleTableCellClick}
                            order={order}
                            orderBy={orderBy}
                            onRequestSort={handleRequestSort}
                        />
                    </Box>
                </Box>
            </Box>
        </>
    )
}

const styles = {
    root: {
        ...importedStyles.root,
        backgroundColor: '#EFEAE7',
        pt: 16,
        pb: 10,
        minHeight: '100vh',
    },

    container: {
        maxWidth: '1440px',
        position: 'relative',
        mx: 'auto',
    },

    hero: {
        justifyContent: 'space-between',
        alignItems: { xs: 'flex-start', md: 'center' },
        mb: { xs: '24px', sm: '40px', },
    },
}